import axios from 'axios';
import { formatIso8601DateTime } from 'utils/dateTimeUtils';
import CustomError from 'utils/CustomError';
import {
  createErrorFromAxiosUserMessageError,
  createErrorFromAxiosMultipleErrors,
} from 'api/utilities';
import { BILLING_COUPON_URL } from 'api/constants';

export function getBillingCoupons(paging, filters) {
  const params = {
    code: filters.searchKeyword,
    page: paging.pageNumber,
    size: paging.pageSize,
  };

  if (filters.startDate) {
    params.startCreatedDate = formatIso8601DateTime(filters.startDate);
  }

  if (filters.endDate) {
    params.endCreatedDate = formatIso8601DateTime(filters.endDate);
  }

  switch (filters.status) {
    case 'on':
      params.status = 'OPEN';
      break;
    case 'off':
      params.status = 'SUSPENDED';
      break;
    case 'ooq':
      params.status = 'OUT_OF_QUOTA';
      break;
    case 'expired':
      params.status = 'EXPIRED';
      break;
    default:
      params.status = '';
      break;
  }

  return axios.get(BILLING_COUPON_URL, {
    params,
  });
}

export function getBillingCouponDetails(couponCode) {
  try {
    return axios.get(`${BILLING_COUPON_URL}/${couponCode}`);
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function getBillingCouponLogs(couponCode, pageNumber, pageSize) {
  const url = `${BILLING_COUPON_URL}/${couponCode}/logs`;
  try {
    return await axios.get(url, {
      params: {
        page: pageNumber,
        size: pageSize,
      },
    });
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function addNewCoupon(data) {
  try {
    return await axios.post(BILLING_COUPON_URL, data);
  } catch (error) {
    if (
      error.response &&
      typeof error.response.data === 'object' &&
      error.response.data.errors
    ) {
      const message = error.response.data;
      throw new CustomError(message);
    }
    throw new CustomError({ errors: [error.message] });
  }
}

export async function updateBillingCoupon(code, action) {
  const url = `${BILLING_COUPON_URL}/${code}/${action}`;
  try {
    return await axios.put(url);
  } catch (error) {
    throw createErrorFromAxiosUserMessageError(error);
  }
}

export async function validateCreateCoupon(data) {
  try {
    return await axios.post(`${BILLING_COUPON_URL}/validate`, data);
  } catch (error) {
    if (
      error.response &&
      typeof error.response.data === 'object' &&
      error.response.data.errors
    ) {
      const messages = error.response.data;
      throw new CustomError(messages);
    }
    throw new CustomError({ errors: [error.message] });
  }
}
